import moment from "moment";
import React from "react";
import { IBasicFilter, IGameInfo } from "../../../../../utils/common-type";
import {
  filterEmptyFiled,
  formatOrder,
  formatTimeFilter,
  getCurrentTimeZone,
  pageSizeList,
} from "../../../../../utils/helper";
import { ISummary } from "../../../../layout";

export interface ILobbyElectronicGameReport {
  gameID: string;
  totalBet: number;
  totalWin: number;
  rtp: number;
  hitRate: number;
  betCount: number;
  playerCount: number;
  jackpot: {
    name: string;
    count: number;
  }[];
}

export interface IElectronicGameReportSummary {
  lobbyDAU: number;
  clubDAU: number;
  totalRevenue: number;
  avgRevenue: number;
  totalRtp: number;
  totalBetCount: number;
  avgBetCount: number;
  totalPlayerCount: number;
  avgPlayerCount: number;
}

export interface IFilter extends IBasicFilter {
  time: moment.Moment[];
  zone: string;
  gameIDs: string[];
}

export interface ISearchProps {
  filter: IFilter;
  setFilter: React.Dispatch<React.SetStateAction<IFilter>>;
  searchSummary: Function;
  gameInfos: IGameInfo[];
  data: ILobbyElectronicGameReport[];
}

export const sortableColumns = [
  "gameID",
  "totalBet",
  "totalWin",
  "betCounts",
  "playerCount",
];

export const buildFilter = (filter: IFilter) => {
  const params: any = {
    startTime: formatTimeFilter(filter.time[0], filter.zone),
    endTime: formatTimeFilter(filter.time[1], filter.zone),
    gameIDs: filter.gameIDs.join(","),
    clubsID: 0,
    page: filter.pages,
    pageSize: filter.pageSize,
    order: formatOrder(filter.order, filter.orderBy),
  };
  return filterEmptyFiled(params);
};

export const defaultFilter: () => IFilter = () => ({
  gameIDs: [],
  time: [moment().startOf("days"), moment().endOf("days")],
  zone: getCurrentTimeZone(),
  pages: 0,
  pageSize: Number(localStorage.getItem("pageSize")) || pageSizeList[0],
});

export const initialSummary: ISummary<IElectronicGameReportSummary>[] = [
  {
    key: "lobbyDAU",
    value: "-",
  },
  {
    key: "totalRevenue",
    value: "-",
  },
  {
    key: "avgRevenue",
    value: "-",
  },
  {
    key: "totalRtp",
    value: "-",
  },
  {
    key: "totalBetCount",
    value: "-",
    isInt: true,
  },
  {
    key: "avgBetCount",
    value: "-",
    isInt: true,
  },
  {
    key: "totalPlayerCount",
    value: "-",
    isInt: true,
  },
  {
    key: "avgPlayerCount",
    value: "-",
    isInt: true,
  },
];
